import React, { useEffect, useMemo, useState } from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import { global } from "@shared/libs/Global";
import { formatNumber, toNum } from "@shared/utils/CommonUtils";
import { snSysWidget003 } from "./icons";

interface Props {
  cdWidget?: string;
  nmWidget?: string;
  searchData?: any;
  refreshKey?: number;
}

const SnSysWidget003: React.FC<Props> = ({
  nmWidget,
  searchData,
  refreshKey,
}) => {
  const { userInfo } = global();
  const [dataSource, setDataSource] = useState<any>();

  const params = useMemo(
    () => ({
      cd_firm: searchData?.cd_firm || userInfo.cd_firm,
      dt: searchData?.dt,
    }),
    [searchData?.cd_firm, searchData?.dt, userInfo.cd_firm]
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const param = {
          id: "sn_sys_widget_003_01",
          params,
        };
        const data: any = await fnGetDataSet(param);
        setDataSource(data?.[0]?.[0] || {});
      } catch (error) {}
    };

    fetchData();
  }, [params, refreshKey]);

  const rows = [
    {
      label: "지시량",
      value: formatNumber(toNum(dataSource?.qt_wo), { fractionDigits: 0 }),
      unit: "개",
    },
    {
      label: "생산량",
      value: formatNumber(toNum(dataSource?.qt_work), { fractionDigits: 0 }),
      unit: "개",
    },
    {
      label: "실적율",
      value: formatNumber(toNum(dataSource?.rt_work), {
        fractionDigits: 1,
      }),
      unit: "%",
    },
    {
      label: "지연수량",
      value: formatNumber(toNum(dataSource?.qt_delay), { fractionDigits: 0 }),
      unit: "개",
    },
  ];

  return (
    <div className="flex h-full min-h-[174px] w-full flex-col rounded-lg border border-gray-100 bg-white px-4 py-3 shadow-sm">
      <div className="mb-4 flex items-center gap-3">
        <div className="aspect-square h-10 shrink-0">
          <img
            src={snSysWidget003}
            alt=""
            className="h-full w-full object-contain"
          />
        </div>
        <div className="truncate text-xl font-bold text-slate-900">{nmWidget}</div>
      </div>

      <div className="flex flex-1 flex-col gap-2">
        {rows.map((row) => (
          <div
            key={row.label}
            className="flex items-baseline justify-between gap-3 text-base font-semibold"
          >
            <span className="shrink-0 text-slate-800">{row.label}</span>
            <span className="min-w-0 whitespace-nowrap text-right text-slate-900">
              {row.value}
              {row.unit && (
                <span className="ml-1 text-sm font-semibold text-slate-700">
                  {row.unit}
                </span>
              )}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SnSysWidget003;
